<template>
  <QuestionMarkIcon
    class="inline-flex h-4 w-4 items-center justify-center text-neutral-300 select-none"
    v-tooltip="tooltip"
  />
</template>

<script setup lang="ts">
import QuestionMarkIcon from '~icons/lucide/circle-help'

defineProps<{ tooltip: string | object }>()
</script>
